import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const ProductLicense: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Product Terms of Use & License: Ieshia Danielle"
        description="Product license and terms of use for digital workbooks, audio content, and media from Ieshia Danielle."
        canonical="https://iamieshiadanielle.com/product-license"
      />
      <div className="min-h-screen bg-[#FAF6F0] text-[#380C1E] flex flex-col font-sans">
        <Header />
        <main className="flex-1 py-16 md:py-24 px-4">
          <div className="max-w-3xl mx-auto bg-white/70 backdrop-blur-md border border-[#E8DEC8] p-8 md:p-12 rounded-3xl shadow-sm">
            <p className="text-xs uppercase font-semibold tracking-widest text-[#9E1B50] mb-2">
              IESHIA DANIELLE
            </p>
            <h1 className="font-serif text-3xl md:text-5xl font-normal text-[#380C1E] mb-4">
              Product Terms of Use & License
            </h1>
            <p className="text-xs text-[#380C1E]/70 mb-8 font-medium">
              Effective date: August 10, 2026
            </p>

            <div className="space-y-6 text-sm md:text-base leading-relaxed text-[#380C1E]/90 font-light">
              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-2 pb-2">
                The Short Version
              </h2>
              <p>
                You bought it for you. Use it fully. Fill in every page, do
                every exercise, live the framework, and tell anyone you want
                what it did for you. What your purchase does not include is the
                right to copy it, share the files or your access, teach it as
                your own, or build your own version of it, even reworded.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                Your License
              </h2>
              <p>
                Your purchase gives you a limited, personal, non-exclusive,
                non-transferable license to use the Materials for your own life
                and growth.
              </p>

              <h2 className="font-serif text-2xl font-normal text-[#380C1E] pt-6 pb-2 border-t border-[#E8DEC8]">
                Contact Us
              </h2>
              <p>
                Questions? Email:{" "}
                <a
                  href="mailto:admin@mail.iamieshiadanielle.com"
                  className="text-[#9E1B50] underline"
                >
                  admin@mail.iamieshiadanielle.com
                </a>
              </p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ProductLicense;
